import styled from "styled-components";

/*
* Поля фильтра в сетке auto-fit: на широком экране укладываются в несколько рядов, на узком
* становятся одним столбцом сами, без брейкпоинтов. Явных рядов не заводим — состав фильтров
* ещё будет меняться, а сетка от этого не зависит.
* */
export const FiltersGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px 16px;
    align-items: end;
    margin-bottom: 16px;
`;

// Кнопка сброса живёт в своей ячейке и прижата к низу, чтобы стоять на одной линии с полями.
export const ResetCell = styled.div`
    display: flex;
    align-items: flex-end;
    min-height: 44px;
`;
